// Firebase Collection Names
export const USERS_COLLECTION = 'users';
export const ANSWERS_COLLECTION = 'answers';

export const TIME_FORMAT = 'MM.DD.YYYY';

// Action Types
export const USER_SIGN_IN = 'USER_SIGN_IN';
export const USER_SIGN_OUT = 'USER_SIGN_OUT';

export const SIGNING_UP = 'SIGNING_UP';
export const SIGN_UP_SUCCESS = 'SIGN_UP_SUCCESS';
export const SIGN_UP_FAILURE = 'SIGN_UP_FAILURE';

export const UPDATE_USER_TABLE_FILTERS = 'UPDATE_USER_TABLE_FILTERS';

export const FETCHING_SITE = 'FETCHING_SITE';
export const FETCH_SITE_SUCCESS = 'FETCH_SITE_SUCCESS';
export const FETCH_SITE_FAILURE = 'FETCH_SITE_FAILURE';

export const RECEIVE_ANSWERS = 'RECEIVE_ANSWERS';
export const RECEIVE_USERS = 'RECEIVE_USERS';
export const RECEIVE_USER = 'RECEIVE_USER';

export const RECEIVE_ADMINS = 'RECEIVE_ADMINS';

export const USER_ONLINE = 'USER_ONLINE';
export const USER_OFFLINE = 'USER_OFFLINE';



// WEBPACK FOOTER //
// ./src/constants/index.js